module.exports = __webpack_public_path__ + "static/media/newmun_logo.6ae3e219.png";